"use strict";

const envMap = {
	test: 'gts.shmyth.cn',
	load: 'load.shmyth.cn',
	licai: 'licai.mingyitech.cn',
	gts: 'gts.cheron.cn',
	pzz: 'pzzhzd.mingyitech.cn',
	zc: '182.54.21.89:8084',
	local: '127.0.0.1:8084'
}

const getBaseUrl = () => {
	// 优先级：自定义域名 > 环境标识 > 默认 gts
	const customHost = process.env.VUE_APP_API_HOST
	if (customHost) return customHost

	const envKey = process.env.VUE_APP_API_ENV
	if (envKey && envMap[envKey]) return envMap[envKey]

	return envMap.pzz
}

// 保留旧变量导出，避免影响已有引用
export const testUrl = envMap.test
export const loadUrl = envMap.load
export const licaiUrl = envMap.licai
export const gtsUrl = envMap.gts
export const pzzUrl = envMap.pzz
export const zcUrl = envMap.zc
export const localUrl = envMap.local

export default {
	baseUrl: getBaseUrl(),
}
